import {
    createColumnDate,
    createColumnInlineSelect,
    createColumnInput,
    createColumnInputNumber
} from "../../../../../../components/table/c-table.logic";
import i18n from "../../../../../../i18n";
import { createLoading } from "../../../../../../utils/loading";
import store from "../../../../../../store";
import lodash from "lodash";
import { conditionFormChecker } from "../../../../../../utils/form";

export const { isLoading, setIsLoading } = createLoading();

export const actionPrefix = "resource/v1/transaction/sendSamplingProduct";

export const callSearch = ({ criteria }) => store.dispatch(`${actionPrefix}/search`, { criteria });

export const callSamplingMethod = ({ searchQuery }) => store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "SAMPLING_METHOD", value: searchQuery });
export const callSamplingTopic = ({ searchQuery }) => store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "SAMPLING_TOPIC", value: searchQuery });

export const createColumns = ({ props, data }) => {
    const { viewOnly, itemsKey } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const items = itemsKey ? lodash.get(modelRef, itemsKey) : modelRef;
    const columns = [];

    columns.push(
        createColumnInput({
            title: () => i18n.global.t("model.sampling.approveCode"),
            dataIndex: "refSampling.approveCode",
            align: "center"
        }),
        createColumnInput({
            title: () => i18n.global.t("views.request.sendSamplingProductInfo.referDoc"),
            dataIndex: "refSampling.refReleaseProduct.refRelease.refInspection.approveCode",
            align: "center"
        }),
        createColumnInput({
            title: () => i18n.global.t("views.request.sendSamplingProductInfo.refHazObject"),
            dataIndex: "refSampling.refReleaseProduct.refInspectionProduct.refInformProduct.refHazObject.nameTh",
            align: "center"
        }),
        createColumnInput({
            title: () => i18n.global.t("views.request.sendSamplingProductInfo.tradeNameTh"),
            dataIndex: "refSampling.refReleaseProduct.refInspectionProduct.refInformProduct.refHaz.tradeNameTh",
            align: "center"
        }),
        createColumnInlineSelect({
            title: () => i18n.global.t("views.request.sendSamplingProductInfo.refTopic"),
            dataIndex: "refTopic",
            items,
            useForm,
            itemsKey,
            inputProp: () => ({ list: callSamplingTopic, optLabel: "value" }),
            search: { name: "refTopic.id" },
            customRenderInputProp: ({ record, key }) =>
                lodash.merge(
                    {
                        disabled: viewOnly,
                        list: callSamplingTopic,
                        optLabel: "value",
                        "onUpdate:value": value => {
                            record.refTopic = value;
                            record.isSave = true;
                        },
                        allowClear: true,
                    },
                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field: { key } } }),
                ),
            width: 200,
        }),
        createColumnInlineSelect({
            title: () => i18n.global.t("views.request.sendSamplingProductInfo.refMethod"),
            dataIndex: "refMethod",
            items,
            useForm,
            itemsKey,
            inputProp: () => ({ list: callSamplingMethod, optLabel: "value" }),
            search: { name: "refMethod.id" },
            customRenderInputProp: ({ record, key }) =>
                lodash.merge(
                    {
                        disabled: viewOnly,
                        list: callSamplingMethod,
                        optLabel: "value",
                        "onUpdate:value": value => {
                            record.refMethod = value;
                            record.isSave = true;
                        },
                        allowClear: true,
                    },
                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field: { key } } })
                )
        }),
        createColumnInput({
            title: () => i18n.global.t("views.request.sendSamplingProductInfo.manufacturer"),
            dataIndex: "refSampling.manufacturer",
            align: "center"
        }),
        createColumnInput({
            title: () => i18n.global.t("views.request.sendSamplingProductInfo.importer"),
            dataIndex: "refSampling.importer",
            align: "center"
        }),
        createColumnInput({
            title: () => i18n.global.t("views.request.sendSamplingProductInfo.refSubStanceType"),
            dataIndex: "refSampling.refReleaseProduct.refInspectionProduct.refInformProduct.refHaz.refSubStanceTypeMain.value",
            align: "center"
        }),
        createColumnDate({
            title: () => i18n.global.t("views.request.sendSamplingProductInfo.manufactureDate"),
            dataIndex: "refSampling.manufactureDate",
            align: "center"
        }),
        createColumnInputNumber({
            title: () => i18n.global.t("views.request.sendSamplingProductInfo.size"),
            dataIndex: "refSampling.size",
            align: "center"
        }),
        createColumnInput({
            title: () => i18n.global.t("views.request.sendSamplingProductInfo.refSizeUnit"),
            dataIndex: "refSampling.refSizeUnit.value",
            align: "center"
        }),
        createColumnInputNumber({
            title: () => i18n.global.t("views.request.sendSamplingProductInfo.qty"),
            dataIndex: "refSampling.qty",
            align: "center"
        }),
        createColumnInput({
            title: () => i18n.global.t("views.request.sendSamplingProductInfo.refQtyUnit"),
            dataIndex: "refSampling.refQtyUnit.value",
            align: "center"
        }),
    );
    return columns;
}